export const DEFAULT_PROJECT_NAME = 'Untitled';
export const DEFAULT_FIRST_PAGE_NAME = 'index';
export const MAX_PROJECT_NAME_LEN = 30;
export const MAX_HISTORY_BUFFER_SIZE = 50;